<template>
  <div class="UpdateDb">
    <v-row>
      <v-col cols="12">
        <p>
          <em
            >برای اعمال تغییرات به صورت خودکار و برای کلیه سالهای موجود از گزینه
            زیر استفاده نمایید.</em
          >
        </p>
      </v-col>
      <v-col cols="12" sm="8" md="5" lg="3">
        <v-btn block @click="btnAutoUpdate_Click" color="primary"
          >بروز رسانی خودکار پایگاه های داده</v-btn
        >
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <p class="mt-2">
          <em
            >برای اعمال تغییرات به صورت دستی از گزینه های زیر استفاده
            نمایید.</em
          >
        </p>
      </v-col>
      <v-col cols="12" sm="8" md="5" lg="3">
        <v-btn block @click="btnChangeDB_Click" color="primary"
          >اعمال تغییرات پایگاه داده</v-btn
        >
      </v-col>
    </v-row>

    <v-row class="mt-2">
      <v-col cols="12" sm="8" md="5" lg="3"
        ><v-btn block @click="btnChangeYearDB_Click" color="primary"
          >اعمال تغییرات پایگاه داده سالیانه</v-btn
        ></v-col
      >
      <v-col cols="12" sm="8" md="5" lg="3">
        <div class="d-flex">
          <span class="center px-1">انتخاب سال:</span>
          <v-select
            solo
            hide-details
            dense
            v-model="cmbYear"
            :items="years"
          ></v-select>
        </div>
      </v-col>
    </v-row>

    <v-row class="mt-2">
      <v-col cols="12" sm="8" md="5" lg="3">
        <v-btn block @click="btnChangeTable_Click" class="mt-1" color="primary"
          >به روز رسانی اطلاعات</v-btn
        >
      </v-col>
    </v-row>

  </div>
</template>

<script>
import EosToastType from "../../model/EosToastType";
import ResultType from "../../model/ResultType";
export default {
  data() {
    return {
      years: [],
      cmbYear: "",
    };
  },
  mounted() {
    this.loadYears();
  },
  methods: {
    loadYears() {
      this.years = [];
      this.years.push("کلیه سالها");
      this.cmbYear = "کلیه سالها";
      this.$store
        .dispatch("getYears")
        .then((result) => {
          ////console.log(result);
          if (result.type === ResultType.success) {
            this.years.push(...result.data);
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || "error",
            });
          }
        })
        .catch((error) => {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: `${error}`,
          });
        });
    },
    btnAutoUpdate_Click() {
      debugger
      this.cmbYear = "کلیه سالها";
      this.$store.dispatch("AutoUpdate").then((result) => {
        ////console.log(result);
        if (result.type === ResultType.success && result.data) {
          this.$EosToast.show({
            type: EosToastType.success,
            msg: this.$t("operationSuccess"),
          });
        } else {
          debugger
          this.$EosToast.show({
            type: EosToastType.error,
            msg: this.$t("operationFailed"),
          });
        }
      });
    },
    btnChangeDB_Click() {
      this.$store.dispatch("ChangeDb").then((result) => {
        ////console.log(result);
        if (result.type === ResultType.success && result.data) {
          this.$EosToast.show({
            type: EosToastType.success,
            msg: this.$t("operationSuccess"),
          });
        } else {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: this.$t("operationFailed"),
          });
        }
      });
    },
    btnChangeYearDB_Click() {
      this.$store.dispatch("ChangeYearDb").then((result) => {
        //console.log(result);
        if (result.type === ResultType.success && result.data) {
          this.$EosToast.show({
            type: EosToastType.success,
            msg: this.$t("operationSuccess"),
          });
        } else {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: this.$t("operationFailed"),
          });
        }
      });
    },
    btnChangeTable_Click() {
      this.$store.dispatch("ChangeTable").then((result) => {
        //console.log(result);
        if (result.type === ResultType.success && result.data) {
          this.$EosToast.show({
            type: EosToastType.success,
            msg: this.$t("operationSuccess"),
          });
        } else {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: this.$t("operationFailed"),
          });
        }
      });
    },
  },
};
</script>

<style>
</style>